import { Button, RemoveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useConfirm } from "melco-shared-logic";
import { useUserProductUnassign } from "../../hooks/users/useUserProductUnassign";
import { isEmpty } from "lodash-es";

type UserProductUnassignActionButtonProps = {
    productCodeToUnassign: string;
    callBackFn?: () => void;
};

export const UserProductUnassignActionButton: React.FC<
    UserProductUnassignActionButtonProps
> = ({ productCodeToUnassign, callBackFn }) => {
    const { t } = useTranslation();

    const unAssignProduct = useUserProductUnassign();

    const confirmUnassign = useConfirm(
        async () => {

            const successfullyUnAssignedProducts = await unAssignProduct(
                productCodeToUnassign
            )

            if (callBackFn && !isEmpty(successfullyUnAssignedProducts)) {


                callBackFn();
            }


        },
        {
            translationPrefix: "users.products.actions.unassign",


        }
    );

    // if (isEmpty(selectedRowKeys)) {
    //     return null;
    // }

    return (
        <Button
            key="unassignProduct"
            icon={<RemoveIcon />}
            onClick={async () => {
                await confirmUnassign();
            }}
            style={{ minWidth: '115px' }}
        >
            {t("users.products.actions.unassign.button")}
        </Button>
    );
};
